import { GlobalAddress } from '@square/dashboard-protos/models/squareup/common/location';
import { ValidateAddressRequest, ValidateAddressResponse } from '@square/dashboard-protos/models/squareup/bizbank/service';
export let ChosenAddress = /*#__PURE__*/function (ChosenAddress) {
  ChosenAddress["Normalized"] = "Normalized";
  ChosenAddress["UserInput"] = "UserInput";
  return ChosenAddress;
}({});
export let AddressValidationResult = /*#__PURE__*/function (AddressValidationResult) {
  AddressValidationResult["NOT_STARTED"] = "ADDRESS_VALIDATION_RESULT_NOT_STARTED";
  AddressValidationResult["VERIFIED"] = "ADDRESS_VALIDATION_RESULT_VERIFIED";
  AddressValidationResult["NORMALIZED"] = "ADDRESS_VALIDATION_RESULT_NORMALIZED";
  AddressValidationResult["UNVERIFIED"] = "ADDRESS_VALIDATION_RESULT_UNVERIFIED";
  AddressValidationResult["ERROR"] = "ADDRESS_VALIDATION_RESULT_ERROR";
  return AddressValidationResult;
}({});

// State
// =============================================================================

export const INITIAL_STATE = {
  address: GlobalAddress.create(),
  result: AddressValidationResult.NOT_STARTED,
  chosenAddress: ChosenAddress.UserInput,
  loading: false,
  normalizedAddress: GlobalAddress.create(),
  updatedAddress: GlobalAddress.create()
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});

// Action
// =============================================================================

export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["ChosenAddressChange"] = "ADDRESS_VALIDATION_CHOSEN_ADDRESS_CHANGE";
  ActionType["NormalizedAddressChange"] = "ADDRESS_VALIDATION_NORMALIZED_ADDRESS_CHANGE";
  ActionType["ValidateAddress"] = "ADDRESS_VALIDATION_VALIDATE_ADDRESS";
  ActionType["ValidateAddressReceived"] = "ADDRESS_VALIDATION_VALIDATE_SHIPPING_ADDRESS_RECEIVED";
  ActionType["ValidateAddressRejected"] = "ADDRESS_VALIDATION_VALIDATE_SHIPPING_ADDRESS_REJECTED";
  ActionType["ValidationCompleted"] = "ADDRESS_VALIDATION_VALIDATION_COMPLETED";
  return ActionType;
}({});
// Action Creators
// =============================================================================

export const chosenAddressChangeAction = chosenAddress => ({
  type: ActionType.ChosenAddressChange,
  chosenAddress
});
export const normalizedAddressChangeAction = normalizedAddress => ({
  type: ActionType.NormalizedAddressChange,
  normalizedAddress
});
export const validationCompletedAction = () => ({
  type: ActionType.ValidationCompleted
});
export const validateAddressAction = address => ({
  type: ActionType.ValidateAddress,
  address
});
export const validateAddressReceivedAction = response => ({
  type: ActionType.ValidateAddressReceived,
  response
});
export const validateAddressRejectedAction = error => ({
  type: ActionType.ValidateAddressRejected,
  error
});

// Update
// =============================================================================

function handleValidateAddressAction(context, state, action) {
  const work = () => context.validateAddress(ValidateAddressRequest.create({
    address: action.address
  })).then(validateAddressReceivedAction, validateAddressRejectedAction);
  return [{
    ...state,
    loading: true
  }, work];
}
function handleValidateAddressReceived(_context, state, action) {
  const {
    response
  } = action;
  const {
    addressNormalizationResult,
    correctedFields,
    normalizedAddress
  } = response;
  switch (addressNormalizationResult) {
    case ValidateAddressResponse.AddressNormalizationResult.VERIFICATION_FAILED:
    case ValidateAddressResponse.AddressNormalizationResult.SUCCESS:
      {
        let chosenAddress = ChosenAddress.UserInput;
        let result = AddressValidationResult.UNVERIFIED;
        if (correctedFields.length === 0 && addressNormalizationResult === ValidateAddressResponse.AddressNormalizationResult.SUCCESS) {
          result = AddressValidationResult.VERIFIED;
        } else if (correctedFields.length > 0 && normalizedAddress) {
          chosenAddress = ChosenAddress.Normalized;
          result = AddressValidationResult.NORMALIZED;
        }
        return [{
          ...state,
          result,
          chosenAddress,
          normalizedAddress: normalizedAddress ?? state.normalizedAddress,
          loading: false
        }, () => validationCompletedAction()];
      }
    case ValidateAddressResponse.AddressNormalizationResult.VERIFICATION_NOT_AVAILABLE:
    case ValidateAddressResponse.AddressNormalizationResult.UNKNOWN_ERROR:
    default:
      {
        return [{
          ...state,
          loading: false,
          result: AddressValidationResult.ERROR
        }, () => validationCompletedAction()];
      }
  }
}
function handleValidateAddressRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Validate address - ${error}`);
  return [{
    ...state,
    result: AddressValidationResult.ERROR,
    loading: false
  }, () => validationCompletedAction()];
}
export const update = context => (state, action) => {
  switch (action.type) {
    case ActionType.ChosenAddressChange:
      {
        const chosenAddress = action.chosenAddress;
        return [{
          ...state,
          chosenAddress
        }, null];
      }
    case ActionType.NormalizedAddressChange:
      {
        const normalizedAddress = action.normalizedAddress;
        return [{
          ...state,
          normalizedAddress
        }, null];
      }
    case ActionType.ValidateAddress:
      return handleValidateAddressAction(context, state, action);
    case ActionType.ValidateAddressReceived:
      return handleValidateAddressReceived(context, state, action);
    case ActionType.ValidateAddressRejected:
      return handleValidateAddressRejected(context, state, action);
    case ActionType.ValidationCompleted:
      {
        // The purpose of this action is to signal the parent workflow
        // when the validation state updates are done
        return [state, null];
      }
  }
};